import { ContentViewModel } from '@levelapp/softfabric';
import { Animated, Easing } from 'react-native';
export default class ToastWebViewModel extends ContentViewModel {
    constructor(view) {
        super(view);
        this.initialState({
            translateX: new Animated.Value(400),
            opacity: new Animated.Value(0)
        });
        this.animateToast(0, 1);
    }
    componentDidMount() {
        setTimeout(() => {
            this.animateToast(400, 0);
        }, this.props().time == undefined || this.props().time == 0 ? 2200 : this.props().time);
    }
    animateToast(translateX, opacity) {
        Animated.parallel([
            Animated.timing(this.state().translateX, {
                toValue: translateX,
                useNativeDriver: true,
                duration: 300,
                easing: Easing.cubic
            }),
            Animated.timing(this.state().opacity, {
                toValue: opacity,
                useNativeDriver: true,
                easing: Easing.cubic
            })
        ]).start();
    }
    getColorForType() {
        switch (this.props().type) {
            case 'success':
                return '#46BE8B';
            case 'info':
                return '#1b85b8';
            case 'error':
                return '#E31E42';
            case 'warning':
                return '#FFB92C';
        }
        return '#BBBBBB';
    }
}
